import http from '@/services';

export const getBrands = () => http.get('logos/');

export const getTags = () => http.get('tags/');

export const getInfluencer = () => http.get('classifications/');

export const getColours = () => http.get('colors/');
